import { Button, Dropdown, message, Tooltip } from 'antd'
import {
  ArrowDownToLine,
  ArrowUpToLine,
  BookMarked,
  MoreVertical,
  Settings2,
  Trash2
} from 'lucide-react'
import { LineItem } from '../../types/ffe'
import { ItemType } from 'antd/es/menu/interface'
import { useFFEStore } from '../../store/ffeStore'
import { useScrollToElement } from '../FloorPlans/hooks/useScrollToElement'
import { useApi } from '../../services/ApiContext'
import { useShallow } from 'zustand/react/shallow'

export const MoreLineItemControls = ({ item }: { item: LineItem }) => {
  const setLineItemDetailsDrawerId = useFFEStore(
    (state) => state.setLineItemDetailsDrawerId
  )
  const moveLineItemToTopOfGroup = useFFEStore(
    (state) => state.moveLineItemToTopOfGroup
  )
  const moveLineItemToBottomOfGroup = useFFEStore(
    (state) => state.moveLineItemToBottomOfGroup
  )
  const removeLineItem = useFFEStore((state) => state.removeLineItem)
  const api = useApi()

  const supplierForLineItem = useFFEStore(useShallow((state) =>
    state.suppliers.find((supplier) => supplier._id === item.supplier)
  ))

  const scrollToElement = useScrollToElement()

  const dropdownItems: Array<ItemType> = [
    // Items for: Move to top of group, move to bottom of group, open line item details, save to product library
    {
      key: 'move-to-top',
      label: 'Move to top',
      icon: <ArrowUpToLine className="h-4 w-4" />,
      onClick: () => {
        moveLineItemToTopOfGroup(item.id)
        setTimeout(() => scrollToElement(`line-item-${item.id}`), 100)
      }
    },
    {
      key: 'move-to-bottom',
      icon: <ArrowDownToLine className="h-4 w-4" />,
      label: 'Move to bottom',
      onClick: () => {
        moveLineItemToBottomOfGroup(item.id)
        setTimeout(() => scrollToElement(`line-item-${item.id}`), 100)
      }
    },
    {
      key: 'open-line-item-details',
      icon: <Settings2 className="h-4 w-4" />,
      label: 'Open line item details',
      onClick: () => {
        setLineItemDetailsDrawerId(item.id)
      }
    },
    {
      icon: <BookMarked className="h-4 w-4" />,
      key: 'save-to-product-library',
      label: 'Save to product library',
      onClick: async () => {
        await api.uploadLineItemToProductLibrary(item, supplierForLineItem?.name)
        message.success('Saved to product library')
      }
    },
    {
      onClick: () => removeLineItem(item.id),
      danger: true,
      icon: <Trash2 className="h-4 w-4" />,
      key: 'delete',
      label: 'Delete item'
    }
  ]

  return (
    <Dropdown
      menu={{
        items: dropdownItems
      }}
      trigger={['click']}
    >
      <Tooltip title="More line item options">
        <Button type="text" icon={<MoreVertical className="h-4 w-4" />} />
      </Tooltip>
    </Dropdown>
  )
}
